/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_What_P1Inputs */

const en_home_what_p1 = /** @type {(inputs: Home_What_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft is a free, open-source computer-aided design and drafting application. It recreates the AutoCAD-style workflow that architects, engineers, students and makers already know, as a clean-room project written from scratch in Rust. The editor is free and open source, with no license fee and no account needed to draw. This site also offers CADCraft Online Pro, an optional paid plan that adds cloud drawings, version history and share links ($4.9/month or $29/year). You can download CADCraft for Windows, macOS, Linux or FreeBSD, or run the very same app in your browser through WebAssembly.`)
};

/**
* | output |
* | --- |
* | "CADCraft is a free, open-source computer-aided design and drafting application. It recreates the AutoCAD-style workflow that architects, engineers, students ..." |
*
* @param {Home_What_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_what_p1 = /** @type {((inputs?: Home_What_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_What_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_what_p1(inputs)
});
export { home_what_p1 as "home.what.p1" }